import React from 'react';
import { categoryCodeToReadableTag } from '../../../../utils/categories';
import { EVENTBRITE_FORMAT_MAPPING } from '../../constants/formats';
import { useRouteContext } from '../../context';
import { useBaseEventsQueryTagsAgg } from '../../hooks/queries/aggregations';
import { CategoryBrowseEvents } from '../CategoryBrowseEvents';

interface CategoryBrowseDynamicFormatEventsProps {
    bucketNumber: number;
    bucketPosition?: string;
}

export const CategoryBrowseDynamicFormatEvents: React.FunctionComponent<
    CategoryBrowseDynamicFormatEventsProps
> = (props) => {
    const { data } = useBaseEventsQueryTagsAgg();
    const { parsedValues } = useRouteContext();
    const activeTag = parsedValues?.activeTag || '';

    if (!data) {
        return null;
    }

    const eligibleFormats = Object.keys(data).filter(
        (item) =>
            item !== 'EventbriteFormat/100' &&
            item.includes('EventbriteFormat') &&
            (data?.[item]?.doc_count || 0) > 3,
    );

    const format = eligibleFormats[props.bucketNumber];

    if (!format || !EVENTBRITE_FORMAT_MAPPING[format]) {
        return null;
    }

    return (
        <CategoryBrowseEvents
            renderLoading={true}
            lazyLoadCarouselElements={true}
            queryOverload={{
                page_size: 8,
                tags: [activeTag, format],
                aggs: {},
            }}
            title={EVENTBRITE_FORMAT_MAPPING[format]}
            bucketKey={categoryCodeToReadableTag(format) || format}
            bucketPosition={props.bucketPosition}
        />
    );
};
